import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "wh-dashboard" }
const _hoisted_2 = {
  key: 0,
  class: "wh-loading"
}
const _hoisted_3 = {
  key: 1,
  class: "wh-metrics"
}
const _hoisted_4 = { class: "metric-num" }
const _hoisted_5 = { class: "metric-card" }
const _hoisted_6 = { class: "metric-num" }
const _hoisted_7 = { class: "metric-num" }
const _hoisted_8 = { class: "metric-num" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Carregando indicadores..."))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", {
            class: _normalizeClass(["metric-card", { 'metric--alert': _ctx.stats.lowStockAlerts > 0 }])
          }, [
            _cache[0] || (_cache[0] = _createElementVNode("svg", {
              class: "metric-icon",
              width: "20",
              height: "20",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "1.8"
            }, [
              _createElementVNode("path", { d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" }),
              _createElementVNode("line", {
                x1: "12",
                y1: "9",
                x2: "12",
                y2: "13"
              }),
              _createElementVNode("line", {
                x1: "12",
                y1: "17",
                x2: "12.01",
                y2: "17"
              })
            ], -1)),
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.stats.lowStockAlerts), 1),
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "metric-label" }, "Estoque Baixo", -1))
          ], 2),
          _createElementVNode("div", _hoisted_5, [
            _cache[2] || (_cache[2] = _createElementVNode("svg", {
              class: "metric-icon",
              width: "20",
              height: "20",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "1.8"
            }, [
              _createElementVNode("path", { d: "M5 12h14M12 5l7 7-7 7" })
            ], -1)),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.stats.withdrawalsToday), 1),
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "metric-label" }, "Saídas Hoje", -1))
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["metric-card", { 'metric--alert': _ctx.stats.lateReturns > 0 }])
          }, [
            _cache[4] || (_cache[4] = _createElementVNode("svg", {
              class: "metric-icon",
              width: "20",
              height: "20",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "1.8"
            }, [
              _createElementVNode("circle", {
                cx: "12",
                cy: "12",
                r: "10"
              }),
              _createElementVNode("polyline", { points: "12 6 12 12 16 14" })
            ], -1)),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.stats.lateReturns), 1),
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "metric-label" }, "Devoluções Atrasadas", -1))
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["metric-card", { 'metric--warn': _ctx.stats.maintenanceOpen > 0 }])
          }, [
            _cache[6] || (_cache[6] = _createElementVNode("svg", {
              class: "metric-icon",
              width: "20",
              height: "20",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "1.8"
            }, [
              _createElementVNode("path", { d: "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" })
            ], -1)),
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.stats.maintenanceOpen), 1),
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "metric-label" }, "Manutenções", -1))
          ], 2)
        ]))
  ]))
}